/**
 * Utility functions for date formatting
 */

/**
 * Formats a date as dd/mm/yy
 * @param dateInput - Date object or string
 * @returns formatted date string like "03/12/25" or empty string if invalid
 */
export function formatDateDDMMYY(dateInput: string | Date | null | undefined): string {
  if (!dateInput) return '';

  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return ''; 

  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0'); 
  const year = d.getFullYear().toString().slice(-2); 

  return `${day}/${month}/${year}`;
}
